// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ABLG","title":"Info_title__21lWZ","selects":"Info_selects__1UaU4","requiredAsterisk":"Info_requiredAsterisk__2Xjae"};